import request from '~/common/utils/request'

export function getBanner () {
  return request({
    url: '/config/banner',
    method: 'get'
  })
}
